import { render, staticRenderFns } from "./JfContent.vue?vue&type=template&id=9f9e80b4&scoped=true&"
import script from "./JfContent.vue?vue&type=script&lang=js&"
export * from "./JfContent.vue?vue&type=script&lang=js&"
import style0 from "./JfContent.vue?vue&type=style&index=0&id=9f9e80b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9e80b4",
  null
  
)

export default component.exports